

/**
 *
 * updateWire Service Sagas
 *
 */

import { take, call, put } from 'redux-saga/effects';
import isObject from 'lodash/isObject';
import isFunction from 'lodash/isFunction';
import { toastr } from 'react-redux-toastr';
import { notAsked, loading, success, failure } from './actions';
import { suspendWireRequest } from './api';
import { SUSPEND_WIRE_REQUEST } from './constants';
import { updateCurrentTransfer } from '../details/actions';


export function* requestFlow(transferId, payload, action, successMessage) {
  // Set the status to LOADING and store the params
  yield put(loading(transferId));

  try {
    // Make the request
    const result = yield call(suspendWireRequest, transferId, payload, action);
    // Set the status to SUCCESS and store the result
    yield put(success(result));
    // Call update current transfer
    yield put(updateCurrentTransfer(result));
    // Toast a success message
    yield call(toastr.success, successMessage || 'Successfully suspended wire');
  } catch (err) {
    let errorBody = err;
    if (isObject(err.response)) {
      if (isFunction(err.response.json)) {
        errorBody = yield err.response.json();
      }
      errorBody.status = err.response.status;
    } else {
      errorBody = errorBody.toString();
    }
    // The .json() method turns the response body into a promise.
    // Set status to FAILURE and pass along the error
    yield put(failure(errorBody));
  }
}

export function* suspendWireServiceFlow() {
  // Set the initial status
  yield put(notAsked());

  while (true) {
    // Watch for SUSPEND_REQUEST to be dispatched
    const {
      transferId,
      payload,
      action,
      successMessage,
    } = yield take(SUSPEND_WIRE_REQUEST);

    // Make the request
    yield call(requestFlow, transferId, payload, action, successMessage);

  }
}

export default [suspendWireServiceFlow()];



// WEBPACK FOOTER //
// ./src/services/suspendWire/sagas.js